import { Component, OnInit } from '@angular/core';
import { RadioGroupItem } from 'src/app/shared/atomic/atoms/radio-group/radio-group.component';
import { MatterFileType, MatterAdjustmentType } from '@models/matter';
import { BusinessDispatch, BusinessState } from '@state/business';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { cloneDeep } from 'lodash';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DefaultAdjstmentOrder } from '@core/util/adjustments';

const fileTypeOptions: RadioGroupItem<MatterFileType>[] = [
	{
		value: MatterFileType.SALE,
		label: 'Sale',
	},
	{
		value: MatterFileType.PURCHASE,
		label: 'Purchase',
	},
];

export const AdjustmentTypeStrings: { [key in MatterAdjustmentType]: string } =
	{
		[MatterAdjustmentType.CommonExpenses]: 'Common Expenses',
		[MatterAdjustmentType.Deposit]: 'Deposit',
		[MatterAdjustmentType.Heat]: 'Heat',
		[MatterAdjustmentType.OccupancyFees]: 'Occupancy Fees',
		[MatterAdjustmentType.Other]: 'Other',
		[MatterAdjustmentType.PropertyTax]: 'Property Tax',
		[MatterAdjustmentType.SalePrice]: 'Sale Price',
		[MatterAdjustmentType.SalePriceHST]: 'HST on sale price',
		[MatterAdjustmentType.SalePriceRebates]: 'HST rebate',
		[MatterAdjustmentType.TarionWarranty]: 'Tarion Warranty',
		[MatterAdjustmentType.TenancyCurrent]: 'Tenancy Current',
		[MatterAdjustmentType.TenancyPrepaid]: 'Tenancy Prepaid',
		[MatterAdjustmentType.HCRA]: 'HCRA',
		[MatterAdjustmentType.VacantTax]: 'Vacant Tax',
		[MatterAdjustmentType.VtbMortgage]: 'VTB Mortgage',
	};

export type AdjustmentDetails = { [key in MatterAdjustmentType]: boolean };

@UntilDestroy()
@Component({
	selector: 'app-adjustment-defaults',
	templateUrl: './adjustment-defaults.component.html',
	standalone: false,
})
export class AdjustmentDefaultsComponent implements OnInit {
	public adjustmentDetailsPurchase = {};
	@Select(BusinessState.getIncludeAdjustmentDetailsPurchase)
	public adjustmentDetailsPurchase$: Observable<AdjustmentDetails>;

	public adjustmentDetailsSale = {};
	@Select(BusinessState.getIncludeAdjustmentDetailsSale)
	public adjustmentDetailsSale$: Observable<{
		[key in MatterAdjustmentType]: boolean;
	}>;

	public adjustmentTypes;
	public fileTypesOptions = fileTypeOptions;
	public selectedFileType = MatterFileType.SALE;
	public testVar = false;

	constructor(private businessDispatch: BusinessDispatch) {
		this.adjustmentTypes = Object.entries(MatterAdjustmentType)
			.map(([key, value]) => ({
				value,
				friendlyName: AdjustmentTypeStrings[value],
				order: DefaultAdjstmentOrder[value],
			}))
			.sort((a, b) => a.order - b.order);
	}

	ngOnInit() {
		this.adjustmentDetailsSale$
			.pipe(untilDestroyed(this))
			.subscribe((adjustmentDetailsSale) => {
				this.adjustmentDetailsSale = cloneDeep(adjustmentDetailsSale);
			});
		this.adjustmentDetailsPurchase$
			.pipe(untilDestroyed(this))
			.subscribe((adjustmentDetailsPurchase) => {
				this.adjustmentDetailsPurchase = cloneDeep(adjustmentDetailsPurchase);
			});
	}

	setAdjustmentDetailsSale(
		$event: boolean,
		adjustmentType: MatterAdjustmentType,
	): void {
		const _newAdjustmentDetailsSale = {
			...this.adjustmentDetailsSale,
		} as AdjustmentDetails;
		_newAdjustmentDetailsSale[adjustmentType] = $event;
		this.businessDispatch.SetIncludeAdjustmentDetailsSale(
			_newAdjustmentDetailsSale,
		);
	}

	setAdjustmentDetailsPurchase(
		$event: boolean,
		adjustmentType: MatterAdjustmentType,
	): void {
		const _newAdjustmentDetailsPurchase = {
			...this.adjustmentDetailsPurchase,
		} as AdjustmentDetails;
		_newAdjustmentDetailsPurchase[adjustmentType] = $event;
		this.businessDispatch.SetIncludeAdjustmentDetailsPurchase(
			_newAdjustmentDetailsPurchase,
		);
	}
}
